import React from 'react'

import type { HistoryParticipationType } from '../../BanksParticipation.types'
import Bank from '../Bank/Bank'
import Nothing from '../Nothing/Nothing'
import styles from './UnBrokenBanks.module.scss'

interface Props {
  historyParticipations: HistoryParticipationType[]
}

const UnBrokenBanks: React.FC<Props> = ({ historyParticipations }) => {
  return (
    <>
      {historyParticipations.length === 0 && <Nothing />}

      <div className={styles.wrapper}>
        {historyParticipations.map((item: HistoryParticipationType) => {
          return <Bank variant='unbroken' bank={item} />
        })}
      </div>
    </>
  )
}

export default UnBrokenBanks
